module.exports = __webpack_public_path__ + "img/世界巨匠.60056144.png";